import './TeuCont.css';
import '../../chaptercontainer.css'

const getTypeOptions = (question) => {
  if (
    Array.isArray(question?.teuContTypeOptions) &&
    question.teuContTypeOptions.length > 0
  ) {
    return question.teuContTypeOptions.map(String);
  }

  if (
    Array.isArray(question?.typeOptions) &&
    question.typeOptions.length > 0
  ) {
    return question.typeOptions.map(String);
  }

  return [];
};

const getAccountOptions = (question) => {
  if (
    Array.isArray(question?.teuContAccountOptions) &&
    question.teuContAccountOptions.length > 0
  ) {
    return question.teuContAccountOptions.map(String);
  }

  if (
    Array.isArray(question?.accountOptions) &&
    question.accountOptions.length > 0
  ) {
    return question.accountOptions.map(String);
  }

  if (
    question?.correctAccount !== undefined &&
    question?.correctAccount !== null
  ) {
    return [String(question.correctAccount)];
  }

  if (question?.account) {
    return [String(question.account)];
  }

  return [];
};

const getAmountOptions = (question) => {
  if (
    Array.isArray(question?.teuContAmountOptions) &&
    question.teuContAmountOptions.length > 0
  ) {
    return question.teuContAmountOptions.map(String);
  }

  if (
    Array.isArray(question?.amountOptions) &&
    question.amountOptions.length > 0
  ) {
    return question.amountOptions.map(String);
  }

  const amounts = [];

  if (
    question?.correctAmountDebit !== undefined &&
    question?.correctAmountDebit !== null
  ) {
    amounts.push(String(question.correctAmountDebit));
  }

  if (
    question?.correctAmountCredit !== undefined &&
    question?.correctAmountCredit !== null
  ) {
    amounts.push(String(question.correctAmountCredit));
  }

  if (amounts.length > 0) {
    return amounts;
  }

  if (
    question?.correctAmount !== undefined &&
    question?.correctAmount !== null
  ) {
    return [String(question.correctAmount)];
  }

  if (
    question?.amount !== undefined &&
    question?.amount !== null
  ) {
    return [String(question.amount)];
  }

  return [];
};

const TeuCont = ({
  question,
  isAnswerChecked,

  typeDrop,
  accountDrop,
  debitAmountDrop,
  creditAmountDrop,
  amountTargetSide,

  typeSourceKey,
  accountSourceKey,
  debitAmountSourceKey,
  creditAmountSourceKey,

  onTypeChange,
  onAccountChange,
  onDebitAmountChange,
  onCreditAmountChange,
  onAmountTargetSideChange,

  onTypeSourceKeyChange,
  onAccountSourceKeyChange,
  onDebitAmountSourceKeyChange,
  onCreditAmountSourceKeyChange,

  onInteraction
}) => {
  const typeOptions =
    getTypeOptions(question);

  const accountOptions =
    getAccountOptions(question);

  const amountOptions =
    getAmountOptions(question);

  const allOptions = [
    ...typeOptions.map((option) => ({
      key: `type-${option}`,
      group: 'type',
      value: String(option)
    })),

    ...accountOptions.map((option) => ({
      key: `account-${option}`,
      group: 'account',
      value: String(option)
    })),

    ...amountOptions.map((option, index) => ({
      key: `amount-${index}-${option}`,
      group: 'amount',
      value: String(option)
    }))
  ];

  const statementHtml =
    question?.statement ||
    question?.context ||
    '';

  const expectedAccount = String(
    question?.correctAccount ??
    question?.account ??
    ''
  );

  const expectedDebitAmount =
    question?.correctAmountDebit !== undefined &&
    question?.correctAmountDebit !== null
      ? String(question.correctAmountDebit)
      : question?.correctSide === 'D'
        ? String(
            question?.correctAmount ??
            question?.amount ??
            ''
          )
        : '';

  const expectedCreditAmount =
    question?.correctAmountCredit !== undefined &&
    question?.correctAmountCredit !== null
      ? String(question.correctAmountCredit)
      : question?.correctSide === 'C'
        ? String(
            question?.correctAmount ??
            question?.amount ??
            ''
          )
        : '';

  const notifyInteraction = () => {
    if (typeof onInteraction === 'function') {
      onInteraction();
    }
  };

  const placeOption = (
    optionItem,
    slot = null
  ) => {
    if (
      isAnswerChecked ||
      !optionItem
    ) {
      return;
    }

    const value =
      String(optionItem.value);

    const key =
      String(optionItem.key);

    if (slot === 'type') {
      onTypeChange(value);
      onTypeSourceKeyChange(key);
      notifyInteraction();
      return;
    }

    if (slot === 'account') {
      onAccountChange(value);
      onAccountSourceKeyChange(key);
      notifyInteraction();
      return;
    }

    if (slot === 'debitAmount') {
      onDebitAmountChange(value);
      onDebitAmountSourceKeyChange(key);
      onAmountTargetSideChange('D');
      notifyInteraction();
      return;
    }

    if (slot === 'creditAmount') {
      onCreditAmountChange(value);
      onCreditAmountSourceKeyChange(key);
      onAmountTargetSideChange('C');
      notifyInteraction();
      return;
    }

    if (!typeDrop) {
      onTypeChange(value);
      onTypeSourceKeyChange(key);
    } else if (!accountDrop) {
      onAccountChange(value);
      onAccountSourceKeyChange(key);
    } else if (
      amountTargetSide === 'C' &&
      !creditAmountDrop
    ) {
      onCreditAmountChange(value);
      onCreditAmountSourceKeyChange(key);
    } else if (
      amountTargetSide === 'D' &&
      !debitAmountDrop
    ) {
      onDebitAmountChange(value);
      onDebitAmountSourceKeyChange(key);
    } else if (!debitAmountDrop) {
      onDebitAmountChange(value);
      onDebitAmountSourceKeyChange(key);
      onAmountTargetSideChange('D');
    } else if (!creditAmountDrop) {
      onCreditAmountChange(value);
      onCreditAmountSourceKeyChange(key);
      onAmountTargetSideChange('C');
    } else if (amountTargetSide === 'C') {
      onCreditAmountChange(value);
      onCreditAmountSourceKeyChange(key);
    } else {
      onDebitAmountChange(value);
      onDebitAmountSourceKeyChange(key);
    }

    notifyInteraction();
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (
    event,
    slot
  ) => {
    event.preventDefault();

    if (isAnswerChecked) {
      return;
    }

    try {
      const raw =
        event.dataTransfer.getData(
          'application/json'
        );

      if (!raw) {
        return;
      }

      const optionItem =
        JSON.parse(raw);

      placeOption(
        optionItem,
        slot
      );
    } catch (error) {
      console.error(error);
    }
  };

  const renderDropClass = (
    value,
    expectedValue
  ) => {
    let className =
      'teu-cont-drop-zone';

    if (!isAnswerChecked) {
      return className;
    }

    if (
      value === null ||
      value === undefined ||
      value === ''
    ) {
      return `${className} teu-cont-drop-zone--disabled`;
    }

    if (
      String(value) ===
      String(expectedValue)
    ) {
      return `${className} teu-cont-drop-zone--correct`;
    }

    return `${className} teu-cont-drop-zone--incorrect`;
  };

  return (
    <div className='quiz-content-scroll-bc'>
    <div className="teu-cont-container">

      <div
        className="teu-cont-statement"
        dangerouslySetInnerHTML={{
          __html: statementHtml
        }}
      />

      <div className="teu-cont-card">

        <div className="teu-cont-header">

          <div
            className={`
              ${renderDropClass(
                typeDrop,
                String(
                  question?.correctType || ''
                )
              )}
              teu-cont-drop-zone--type
              ${typeDrop ? 'teu-cont-drop-zone--filled' : ''}
            `}
            onDragOver={handleDragOver}
            onDrop={(event) =>
              handleDrop(
                event,
                'type'
              )
            }
            onClick={() => {
              if (isAnswerChecked) {
                return;
              }

              onTypeChange(null);
              onTypeSourceKeyChange(null);
            }}
          >
            {typeDrop || 'tip cont'}
          </div>

          <div className="teu-cont-header-row">

            <div className="teu-cont-debit-label">
              D
            </div>

            <div
              className={`
                ${renderDropClass(
                  accountDrop,
                  expectedAccount
                )}
                teu-cont-drop-zone--account
                ${accountDrop ? 'teu-cont-drop-zone--filled' : ''}
              `}
              onDragOver={handleDragOver}
              onDrop={(event) =>
                handleDrop(
                  event,
                  'account'
                )
              }
              onClick={() => {
                if (isAnswerChecked) {
                  return;
                }

                onAccountChange(null);
                onAccountSourceKeyChange(null);
              }}
            >
              {accountDrop || 'cod cont'}
            </div>

            <div className="teu-cont-credit-label">
              C
            </div>

          </div>
        </div>

        <div className="teu-cont-body">

          <div className="teu-cont-side">
            <div
              className={`
                ${renderDropClass(
                  debitAmountDrop,
                  expectedDebitAmount
                )}
                ${debitAmountDrop ? 'teu-cont-drop-zone--filled' : ''}
                ${
                  amountTargetSide === 'D' &&
                  !debitAmountDrop &&
                  !isAnswerChecked
                    ? 'teu-cont-drop-zone--targeted'
                    : ''
                }
              `}
              onDragOver={handleDragOver}
              onDrop={(event) =>
                handleDrop(
                  event,
                  'debitAmount'
                )
              }
              onClick={() => {
                if (isAnswerChecked) {
                  return;
                }

                if (debitAmountDrop) {
                  onDebitAmountChange(null);
                  onDebitAmountSourceKeyChange(null);
                } else {
                  onAmountTargetSideChange('D');
                }
              }}
            >
              {debitAmountDrop || 'suma in D'}
            </div>
          </div>

          <div className="teu-cont-divider" />

          <div className="teu-cont-side">
            <div
              className={`
                ${renderDropClass(
                  creditAmountDrop,
                  expectedCreditAmount
                )}
                ${creditAmountDrop ? 'teu-cont-drop-zone--filled' : ''}
                ${
                  amountTargetSide === 'C' &&
                  !creditAmountDrop &&
                  !isAnswerChecked
                    ? 'teu-cont-drop-zone--targeted'
                    : ''
                }
              `}
              onDragOver={handleDragOver}
              onDrop={(event) =>
                handleDrop(
                  event,
                  'creditAmount'
                )
              }
              onClick={() => {
                if (isAnswerChecked) {
                  return;
                }

                if (creditAmountDrop) {
                  onCreditAmountChange(null);
                  onCreditAmountSourceKeyChange(null);
                } else {
                  onAmountTargetSideChange('C');
                }
              }}
            >
              {creditAmountDrop || 'suma in C'}
            </div>
          </div>

        </div>
      </div>

      {!isAnswerChecked && (
        <div className="teu-cont-options">
          {allOptions.map(
            (optionItem) => {
              const isConsumed =
                optionItem.key ===
                  typeSourceKey ||
                optionItem.key ===
                  accountSourceKey ||
                optionItem.key ===
                  debitAmountSourceKey ||
                optionItem.key ===
                  creditAmountSourceKey;

              return (
                <button
                  key={optionItem.key}
                  type="button"
                  className={`
                    teu-cont-option
                    ${
                      isConsumed
                        ? 'teu-cont-option--used'
                        : ''
                    }
                  `}
                  draggable={!isConsumed}
                  onDragStart={(event) => {
                    if (isConsumed) {
                      return;
                    }

                    event.dataTransfer.setData(
                      'application/json',
                      JSON.stringify(
                        optionItem
                      )
                    );
                  }}
                  onClick={() => {
                    if (isConsumed) {
                      return;
                    }

                    placeOption(
                      optionItem
                    );
                  }}
                >
                  {optionItem.value}
                </button>
              );
            }
          )}
        </div>
      )}

    </div>
    </div>
  );
};

export default TeuCont;